import { h } from 'preact';
import {fetchJson, queryParameters} from '../fetch/fetch';
import async from 'async';
import * as _ from 'underscore';

export class personManager {
	constructor(id, adminDomain = 'https://hazards.colorado.edu/api/v2') {
    this.id = id;
    this.adminDomain = adminDomain;
    this.adminUrl = adminDomain + "/api";
    this.person = {};
    this.commands = [];
  }

  getCommands() {
  	return this.commands;
  }

  getPerson() {
  	const url = this.adminUrl + "/people/"+this.id+"/get-official";
  	const filter = null;
  	this.commands.push({url, filter, key: "person"})
  	return this;
  }

  getSlug() {
  	const url = this.adminUrl + "/slugs/official";
  	const filter = {"where": {"personId": this.id}};
  	this.commands.push({url, filter, key: "slugs"})
  	return this;
  }

  getAvatar() {
  	const filter = {"where": {"relatedId": this.id, "relatedType": "Person", "type": "avatar"}};
  	this.getFiles(filter, "avatar")
  	return this;
  }

  getBiography(where = {}) {
  	const url = this.adminUrl + "/biographies/official";
  	const personId = {"personId": this.id};
  	const filter = {where: {...personId, ...where}};
  	this.commands.push({url, filter, key: "biographies"});
  	return this;
  }

  getEmail(where = {}) {
    const url = this.adminUrl + "/EmailAddresses/public";
    const personId = {"personId": this.id};
    const filter = {where: {...personId, ...where}};
    this.commands.push({url, filter, key: "email"});
    return this;
  }

  getCV() {
  	const filter = {"where": {"relatedId": this.id, "relatedType": "Person", "type": "cv"}}
  	this.getFiles(filter, "cv");
  	return this;
  }

  getAffiliation() {
  	const url = this.adminUrl + "/affiliationRelations";
  	const filter = {"where": {"relatedId": this.id, "relatedType": "Person"}};
  	this.commands.push({url, filter, key: "affiliationRelations"});
  	return this;
  }

  getFiles(filter, key) {
  	const url = this.adminUrl + "/fileRelations/official";
  	this.commands.push({url, filter, key});
  }

  implementExecution(url, filter) {
  	let fetchUrl = url;
  	if(filter && Object.keys(filter).length) {
  		fetchUrl = fetchUrl + '?' + queryParameters({filter: JSON.stringify(filter)})
  	}
  	return fetchJson(fetchUrl , {})
		.then(function(response) {
			if((_.isArray(response.json) && response.json.length) ||
          (_.isObject(response.json) && Object.keys(response.json).length > 0) ) 
      {
				return response.json;
			}
		})
		.catch(function(err) {
			//ignore missing, simply don't populate
			if(err.status === 404)
			{
				return null;
			}
			return Promise.reject(err);
		})
  }

  execute(next) {
  	let parallelSet = [];
  	let implementExecution = this.implementExecution;
  	this.commands.forEach(function (command) {
			parallelSet.push(function(nextParallel) {
				return implementExecution(command.url, command.filter)
				.then((response) => {
          let obj = {};
          obj["key"] = command.key;
          obj["response"] = response;
					nextParallel(null, obj);
				})
				.catch((err) => {
					nextParallel(err);
				});
			});
		});

		async.parallel(parallelSet, function(err, result) {
			if (err) return next(err);

			next(null, result);
		})
  }
}